// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HxpT","type":"styles_type__3-FSn","choices":"styles_choices__3bod0"};